export default __webpack_public_path__ + "static/media/Foto29.7155b39d.png";